<template>
	<div v-if="richTextDocument" class="rich-text-editor">
		<RichTextWrapper>
			<RichTextRenderer :document="richTextDocument" />
		</RichTextWrapper>
	</div>
</template>

<script setup lang="ts">
	import type {DocumentNode} from '@marvr/storyblok-rich-text-types';
	import {RichTextRenderer} from '@marvr/storyblok-rich-text-vue-renderer';
	import {applyRichTextImageMarks} from '~/utils/applyRichTextImageMarks';
	import type {RichtextStoryblok} from '~/storyblok/types';

	interface Props {
		data?: RichtextStoryblok | DocumentNode
	}

	const props = defineProps<Props>();

	const richTextDocument = computed(() => (
		props.data
			? applyRichTextImageMarks(props.data as DocumentNode)
			: undefined
	));

	const RichTextWrapper = defineComponent({
		name: 'RichTextWrapper',
		inheritAttrs: false,
		render() {
			return this.$slots?.default?.();
		},
	});
</script>
